// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2rN1S";
var _4 = "card-1ZbCZ";
var _5 = "locations-1Jshf";
var _6 = "location-1oY6K";
var _7 = "flight-2vNau";
var _8 = "transfer-IT3HT";
var _9 = "isMobile-3YhNz";
var _a = "technicalLandingIn-Dh7CW";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "card", _5 as "locations", _6 as "location", _7 as "flight", _8 as "transfer", _9 as "isMobile", _a as "technicalLandingIn" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "card": _4, "locations": _5, "location": _6, "flight": _7, "transfer": _8, "isMobile": _9, "technicalLandingIn": _a }
